import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface SearchIconPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
}

export const SearchIcon = observer('SearchIcon', ({ className, onClick }: SearchIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            fill='none'
            height='16'
            onClick={onClick}
            width='17'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.5362 9.6382a4.0359 4.0359 0 0 0 .5749-2.0826c0-2.2399-1.8157-4.0556-4.0555-4.0556C5.8157 3.5 4 5.3157 4 7.5556c0 2.2398 1.8157 4.0555 4.0556 4.0555a4.036 4.036 0 0 0 2.0826-.5749c.0296.0403.0626.0788.0991.1153l1.5556 1.5556c.3905.3905 1.0237.3905 1.4142 0 .3905-.3905.3905-1.0237 0-1.4142l-1.5556-1.5556a1.0106 1.0106 0 0 0-.1153-.0991Zm-3.4806.9729C6.368 10.6111 5 9.2431 5 7.5556 5 5.868 6.368 4.5 8.0556 4.5c1.6875 0 3.0555 1.368 3.0555 3.0556 0 1.6875-1.368 3.0555-3.0555 3.0555Z'
                fill='#141922'
                opacity='.4'
            />
        </SvgElement>
    );
});
